import {
  query,
  save,
  modify,
  offline,
  online,
  resume,
  suspend,
  remove,
  queryDingding,
  debug,
  unDebug,
  copyDc,
  copyOwner,
  exportInterface,
  importInterface,
  isSupportFieldUpdate,
  getEventTypes,
  getAllInterfaceType,
  getAllMenuName,
} from '@/services/down/apiconfig';

export default {
  namespace: 'apiconfig',
  state: {
    data: {
      dataSource: [],
      pagination: {},
    },
    createModalVisible: false,
    editEntity: undefined,
    entity: undefined,
  },

  effects: {
    *queryDingding({ payload, callback }, { call, put }) {
      const response = yield call(queryDingding, payload);
      if (callback) callback(response);
    },
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
      if (response.success) {
        yield put({
          type: 'success',
          payload: {
            dataSource: response.data.records,
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more
                ? undefined
                : total => `共 ${total} 条`,
            },
          },
        });
      }
    },
    *remove({ payload, callback }, { call, put }) {
      const response = yield call(remove, payload);
      if (callback) callback(response);
    },
    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },
    *offline({ payload, callback }, { call, put }) {
      const response = yield call(offline, payload);
      if (callback) callback(response);
    },
    *online({ payload, callback }, { call, put }) {
      const response = yield call(online, payload);
      if (callback) callback(response);
    },
    *suspend({ payload, callback }, { call, put }) {
      const response = yield call(suspend, payload);
      if (callback) callback(response);
    },
    *resume({ payload, callback }, { call, put }) {
      const response = yield call(resume, payload);
      if (callback) callback(response);
    },
    *debug({ payload, callback }, { call, put }) {
      const response = yield call(debug, payload);
      if (callback) callback(response);
    },
    *unDebug({ payload, callback }, { call, put }) {
      const response = yield call(unDebug, payload);
      if (callback) callback(response);
    },
    *copyDc({ payload, callback }, { call, put }) {
      const response = yield call(copyDc, payload);
      if (callback) callback(response);
    },
    *copyOwner({ payload, callback }, { call, put }) {
      const response = yield call(copyOwner, payload);
      if (callback) callback(response);
    },
    *exportInterface({ payload, callback }, { call, put }) {
      const response = yield call(exportInterface, payload);
      if (callback) callback(response);
    },
    *importInterface({ payload, callback }, { call, put }) {
      const response = yield call(importInterface, payload);
      if (callback) callback(response);
    },
    *isSupportFieldUpdate({ payload, callback }, { call, put }) {
      const response = yield call(isSupportFieldUpdate, payload);
      if (callback) callback(response);
    },
    *getEventTypes({ payload, callback }, { call, put }) {
      const response = yield call(getEventTypes);
      if (callback) callback(response);
    },
    *getAllInterfaceType({ payload, callback }, { call, put }) {
      const response = yield call(getAllInterfaceType);
      if (callback) callback(response);
    },
    *getAllMenuName({ payload, callback }, { call, put }) {
      const response = yield call(getAllMenuName);
      if (callback) callback(response);
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    saveEntity(state, action) {
      return {
        ...state,
        entity: action.payload,
      };
    },
  },
};
